import { RouteObject } from "react-router-dom";
import { navPaths } from "../../constants/navbar.constants";
import SeedGo from "./Pages/SeedGo";
import Inventory from "./Pages/Inventory";

export const seedGoRoute: RouteObject = {
  path: "",
  children: [
    { path: navPaths.SEEDGO, Component: SeedGo },
    { path: navPaths.SEEDGO_INVENTORY, Component: Inventory },
  ],
};
